import React, { SVGAttributes } from 'react';

const LockClockBadgeIcon: React.FC<SVGAttributes<SVGElement>> = ({ ...props }) => {
  const fillColor = props.fill || Styles.color.contrastBackground;
  return (
    <svg data-dir="ltr" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <g id="lock_clock">
        <g id="Vector">
          <path
            d="M2.99984 13.3333V6.66663H10.9998V7.33329C11.4665 7.33329 11.9132 7.39996 12.3332 7.52663V6.66663C12.3332 5.93329 11.7332 5.33329 10.9998 5.33329H10.3332V3.99996C10.3332 2.15996 8.83984 0.666626 6.99984 0.666626C5.15984 0.666626 3.6665 2.15996 3.6665 3.99996V5.33329H2.99984C2.2665 5.33329 1.6665 5.93329 1.6665 6.66663V13.3333C1.6665 14.0666 2.2665 14.6666 2.99984 14.6666H7.17317C6.89317 14.2666 6.67317 13.8133 6.5265 13.3333H2.99984ZM4.99984 3.99996C4.99984 2.89329 5.89317 1.99996 6.99984 1.99996C8.1065 1.99996 8.99984 2.89329 8.99984 3.99996V5.33329H4.99984V3.99996Z"
            fill={fillColor}
          />
          <path
            d="M10.9998 8.66663C9.15984 8.66663 7.6665 10.16 7.6665 12C7.6665 13.84 9.15984 15.3333 10.9998 15.3333C12.8398 15.3333 14.3332 13.84 14.3332 12C14.3332 10.16 12.8398 8.66663 10.9998 8.66663ZM12.0998 13.5666L10.6665 12.1333V9.99996H11.3332V11.86L12.5665 13.0933L12.0998 13.5666Z"
            fill={fillColor}
          />
        </g>
      </g>
    </svg>
  );
};

export default LockClockBadgeIcon;
